import Vue from 'vue'
import VueRouter from 'vue-router'
// import versionTood from '@/utils/versionUpdate'
Vue.use(VueRouter);

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}

const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
	return VueRouterReplace.call(this, to).catch(err => err)
}

// 含有头部底部的页面路由
const hasNavPages = [{
		path: '/deepseekIndex',
		name: 'DeepseekIndex',
		component: () => import('@/views/pages/deepseek/deepseekIndex.vue')
	},
	{
		path: '/ragIndex',
		name: 'RagIndex',
		component: () => import('@/views/pages/rag/ragIndex.vue')
	},
	
	
	{
		path: '/compiling',
		name: 'Compiling',
		component: () => import('@/views/pages/compiling.vue')
	},
	// 外来数据
	{
		path: '/pmidDocument',
		name: 'PmidDocument',
		component: () => import('@/views/pages/foreign/pmidDocument.vue')
	},
	{
		path: '/pmidsAi',
		name: 'PmidsAi',
		component: () => import('@/views/pages/foreign/moreDocument/pmidsAi.vue')
	},
	
]

// 不显示头部底部的页面
const notNavPages = [{
		path: '/scienceAiRag',
		name: 'ScienceAiRag',
		component: () => import('@/views/pages/rag/questionsAndAnswers/index.vue')
	},
	{
		path: '/lookPdf',
		name: 'LookPdf',
		component: () => import('@/views/pages/lookPdf.vue')
	},
	{
		path: '/scienceAi',
		name: 'ScienceAi',
		component: () => import('@/views/pages/deepseek/questionsAndAnswers/index.vue')
	},
	{
		path: '/morequestionsAndAnswers',
		name: 'MorequestionsAndAnswers',
		component: () => import('@/views/pages/foreign/moreDocument/morequestionsAndAnswers.vue')
	},
	{  // 思维导图 全文总结
		path: '/mindMapAndSummary',
		name: 'MindMapAndSummary',
		component: () => import('@/views/pages/shared/mindMapAndSummary.vue')
	},
	{
		path: '/document',
		name: 'Document',
		component: () => import('@/views/pages/document/index.vue')
	},
]


const router = new VueRouter({
	routes: [{
			path: '/',
			name: 'Index',
			redirect: 'home',
			component: () => import('@/views/index.vue'),
			children: [{
					path: '/home',
					name: 'Home',
					redirect: `${process.env.VUE_APP_ITEM == 'deepseek' ? 'deepseekIndex' : 'ragIndex'}`,
					component: () => import('@/views/home.vue'),
					children: [
						...hasNavPages,
					]
				},
				...notNavPages,
				{
					path: '/noPermission',
					name: 'noPermission',
					component: () => import('@/views/noPermission.vue'),
				},
			]
		},
		{
			path: '/404',
			component: () => import('@/views/404.vue')
		},
		{
			path: '*',
			redirect: '/404'
		}
	]
})

// 路由跳转前
router.beforeEach((to, from, next) => {
	// 可用于拦截导航并执行一些操作，例如验证用户身份、权限控制等。
	// versionTood.isNewVersion();
	if (to.meta.title) {
		document.title = to.meta.title
	} else {
		document.title = process.env.VUE_APP_ITEM == 'deepseek' ? 'PubMed x deepseek' : 'Department x deepseek'
	}
	next()
})

// 路由跳转后
router.afterEach((to, from) => {
	window.scrollTo(0, 0) // 每次路由改变滚动条都回到顶部
})

export default router
